import React, { useState, forwardRef } from "react";
import "./Contact.css";
import { motion } from "framer-motion";
import toast from "react-hot-toast";

export const Contact = forwardRef((props, ref) => {
	const [formData, setFormData] = useState({
		firstName: "",
		lastName: "",
		email: "",
		phone: "",
		eventType: "",
		message: ""
	});

	const handleChange = (e) => {
		const { name, value } = e.target;
		if (name === "phone") {
			setFormData(prev => ({ ...prev, phone: value.replace(/\D/g, "") }));
		} else {
			setFormData(prev => ({ ...prev, [name]: value }));
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const { firstName, lastName, email, phone } = formData;

		if (!firstName || !lastName || !email || !phone) {
			toast.error("Please fill in all required fields.");
			return;
		}

		if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
			toast.error("Please enter a valid email address.");
			return;
		}

		if (!/^\d{10}$/.test(phone)) {
			toast.error("Please enter a valid 10-digit phone number.");
			return;
		}

		toast.success("Thank you! We'll be in touch soon.");
		setFormData({
			firstName: "",
			lastName: "",
			email: "",
			phone: "",
			eventType: "",
			message: ""
		});
	};

	const eventTypes = [
		{ value: "", label: "Select Occasion" },
		{ value: "birthday", label: "Birthday" },
		{ value: "wedding", label: "Wedding" },
		{ value: "corporate", label: "Corporate Event" },
		{ value: "baby-shower", label: "Baby Shower" },
		{ value: "anniversary", label: "Anniversary" },
		{ value: "other", label: "Other" }
	];

	return (
		<section ref={ref} id="contact" className="contact section-padding">
			<div className="container">
				<motion.div
					initial={{ opacity: 0, y: 40 }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true, amount: 0.2 }}
					transition={{ duration: 0.8 }}
				>
					<div className="contact-layout">
						<div className="contact-text">
							<p className="contact-label">Get in Touch</p>
							<h2 className="contact-title">Contact Us</h2>
							<p className="contact-description">
								Ready to elevate your next celebration? Share your vision and we'll
								bring it to life with artistry and care.
							</p>

							<div className="contact-details-list">
								<div className="contact-detail">
									<span className="contact-detail-label">Email</span>
									<a href="mailto:airestudioltd@gmail.com">airestudioltd@gmail.com</a>
								</div>
								<div className="contact-detail">
									<span className="contact-detail-label">Phone</span>
									<a href="tel:+16049284992">(604) 928-4992</a>
								</div>
								<div className="contact-detail">
									<span className="contact-detail-label">Hours</span>
									<span>Mon-Fri 10AM-6PM<br />Sat 10AM-2PM</span>
								</div>
							</div>
						</div>

						<div className="contact-form-side">
							<form className="contact-form" onSubmit={handleSubmit}>
								<div className="contact-form-row">
									<input
										type="text"
										name="firstName"
										placeholder="First Name *"
										value={formData.firstName}
										onChange={handleChange}
										className="contact-input"
										required
									/>
									<input
										type="text"
										name="lastName"
										placeholder="Last Name *"
										value={formData.lastName}
										onChange={handleChange}
										className="contact-input"
										required
									/>
								</div>
								<input
									type="email"
									name="email"
									placeholder="Email *"
									value={formData.email}
									onChange={handleChange}
									className="contact-input"
									required
								/>
								<input
									type="tel"
									name="phone"
									placeholder="Phone *"
									value={formData.phone}
									onChange={handleChange}
									className="contact-input"
									maxLength={10}
									required
								/>
								<select
									name="eventType"
									value={formData.eventType}
									onChange={handleChange}
									className="contact-select"
								>
									{eventTypes.map(type => (
										<option key={type.value} value={type.value}>
											{type.label}
										</option>
									))}
								</select>
								<textarea
									name="message"
									placeholder="Tell us about your vision..."
									value={formData.message}
									onChange={handleChange}
									className="contact-textarea"
									rows={5}
								/>
								<button type="submit" className="contact-submit">
									Send Message
								</button>
							</form>
						</div>
					</div>
				</motion.div>
			</div>
		</section>
	);
});
